/* NOT TOYS 2026 · global JS (lane L1 Shell, 22 Oct). No libraries.
   Ported from the preview (home-pm.html + index.html): menu, promo strip, header glass, header slide-away on the
   shop pages, the phone tab bar; plus the real cart (Shopify AJAX cart API + Section Rendering API).

   Public hooks for the other lanes (documented in _notes-L1.md):
     NT.formatMoney(cents[, format])  -> the shop's money format, e.g. '<span class=money>EGP 12,954.00</span>'
     NT.setMoney(el, cents)           -> writes a price into el as a .money span (innerHTML)
     NT.cart.add(items|{id,quantity,properties}[, {open:true, button}]) -> Promise(cart-add response)
     NT.cart.addForm(form[, button])  -> adds a product form (FormData: id, quantity, properties[...], selling_plan)
     NT.cart.open() / close() / refresh({open}) / change(key, qty) / count
     NT.toast(text)
     NT.lg.attach()                   -> the header glass refraction on any new .lg[data-lg] element
     NTTabBar.setCount(n)             -> kept from the preview
   Events (on document):
     'nt:cart-updated'  detail {count, source:'add'|'change'|'note'|'refresh', items?}  (after every cart change)
     'nt:cart-added'    detail {items}                                                 (after a successful add)
     'nt:cart-error'    detail {message}
     'nt:prices-updated' detail {root}  (after the drawer or a cart block was re-rendered; for the currency app)
   Listened to:
     'nt:cart-refresh'  (detail {open:true} opens the drawer) -> re-render the drawer + counts
     'nt:cart:open'     -> re-render the drawer + counts, then open it (use after your own /cart/add.js call)
     Focal's 'variant:added' / 'cart:refresh' (the theme's own product-form) -> refresh + open the drawer
     any <form action=".../cart/add"> submit that nobody else handled -> AJAX add + open the drawer */
(() => {
  'use strict';
  const NT = (window.NT = window.NT || {});
  const cfg = NT.cfg || {};
  const R = (cfg.routes = cfg.routes || {});
  const root = document.documentElement;
  const $ = (id) => document.getElementById(id);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const phone = matchMedia('(max-width: 899px)');
  const route = (k, d) => (R[k] || d).replace(/\/$/, '');

  /* ---------------- money: Shopify.formatMoney with the shop's own format (keeps <span class=money>) ---------------- */
  const delimit = (cents, precision, thousands = ',', decimal = '.') => {
    if (cents == null || isNaN(cents)) return '0';
    const n = (Number(cents) / 100).toFixed(precision);
    const parts = n.split('.');
    return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (parts[1] ? decimal + parts[1] : '');
  };
  NT.formatMoney = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return Number(cents) % 100 === 0 ? delimit(cents, 0) : delimit(cents, 2);   // like money_without_trailing_zeros
        case 'amount_no_decimals': return delimit(cents, 0);
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return delimit(cents, 0, ' ');
        case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return delimit(cents, 2, ' ', '.');
        default: return delimit(cents, 2);
      }
    });
  };
  // the format already wraps the number in <span class=money>; wrap it when a format does not
  NT.setMoney = (el, cents) => {
    if (!el) return;
    const html = NT.formatMoney(cents);
    el.innerHTML = /class=["']?money/.test(html) ? html : `<span class="money">${html}</span>`;
    pricesUpdated(el);
  };
  const pricesUpdated = (el) => {
    document.dispatchEvent(new CustomEvent('nt:prices-updated', { detail: { root: el } }));
    // Currency Converter Plus watches the page for changes; these calls only run if a converter exposes them
    try { if (window.DoublyGlobalCurrency && window.DoublyGlobalCurrency.convertAll) window.DoublyGlobalCurrency.convertAll(); } catch (e) { /* not installed */ }
    try { if (window.Currency && typeof window.Currency.convertAll === 'function' && window.Currency.currentCurrency) window.Currency.convertAll(window.Currency.shopCurrency, window.Currency.currentCurrency); } catch (e) { /* not installed */ }
  };

  /* ---------------- toast ---------------- */
  NT.toast = (text, ms = 2600) => {
    const el = $('ntToast'); if (!el || !text) return;
    el.textContent = text; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, ms);
  };

  /* ---------------- promo strip (home): close for this visit ---------------- */
  const promoX = $('promoX');
  try { if (sessionStorage.getItem('nt-promo-x') === '1' && $('promo')) document.body.classList.add('no-promo'); } catch (e) { /* storage blocked */ }
  if (promoX) promoX.addEventListener('click', () => {
    document.body.classList.add('no-promo');
    try { sessionStorage.setItem('nt-promo-x', '1'); } catch (e) { /* storage blocked */ }
  });

  /* ---------------- menu: open/close, one group at a time, Esc ---------------- */
  const menu = $('menu'), mb = $('ntMenuBtn');
  const setMenu = (open) => {
    if (!menu || !mb) return;
    if (open) {
      document.body.classList.remove('hdr-away');
      const r = document.querySelector('#top .row');
      if (r) menu.style.setProperty('--menu-top', Math.round(r.getBoundingClientRect().bottom) + 'px');
    }
    menu.hidden = !open;
    mb.setAttribute('aria-expanded', String(open));
    mb.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    document.body.classList.toggle('menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  NT.menu = { open: () => setMenu(true), close: () => setMenu(false) };
  if (menu && mb) {
    mb.addEventListener('click', () => setMenu(menu.hidden));
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
    // name="mgroup" makes the accordion exclusive in new browsers; this covers older Safari ('toggle' does not bubble)
    menu.addEventListener('toggle', (e) => {
      const d = e.target;
      if (d.matches && d.matches('details.mgroup') && d.open) menu.querySelectorAll('details.mgroup[open]').forEach((o) => { if (o !== d) o.open = false; });
    }, true);
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); mb.focus(); } });
    // keyboard: while the menu is open, Tab cycles between the menu button and the menu (never the page behind it)
    addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || menu.hidden) return;
      const f = [mb, ...menu.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])')].filter((x) => x.offsetParent !== null || x === mb);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1], inside = f.includes(document.activeElement);
      if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------- phones, shop pages: the header slides away on scroll down, back on scroll up ---------------- */
  if (document.body.classList.contains('nt-hdr-auto')) {
    let lastY = scrollY;
    addEventListener('scroll', () => {
      const y = scrollY, d = y - lastY;
      if (Math.abs(d) < 8) return;
      const away = phone.matches && d > 0 && y > 160 && !document.body.classList.contains('menu-open');
      document.body.classList.toggle('hdr-away', away);
      lastY = y;
    }, { passive: true });
  }

  /* ---------------- liquid glass: refraction lens on the bar (Chromium), rim light that turns with the scroll ---------------- */
  NT.lg = (() => {
    const ua = navigator.userAgent, refract = /Chrome\/\d+/.test(ua) && !/iPhone|iPad|iPod|Firefox/.test(ua) && !reduce;
    const NS = 'http://www.w3.org/2000/svg';
    let defs = null;
    const cache = new Map();
    const lensMap = (w, h, r, bevel) => {
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const ctx = c.getContext('2d'), img = ctx.createImageData(w, h), d = img.data, hw = w / 2, hh = h / 2;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        const px = x + 0.5 - hw, py = y + 0.5 - hh, qx = Math.abs(px) - (hw - r), qy = Math.abs(py) - (hh - r);
        let sd, nx, ny;
        if (qx > 0 && qy > 0) { const l = Math.hypot(qx, qy) || 1; sd = l - r; nx = (qx / l) * Math.sign(px); ny = (qy / l) * Math.sign(py); }
        else if (qx > qy) { sd = qx - r; nx = Math.sign(px); ny = 0; } else { sd = qy - r; nx = 0; ny = Math.sign(py); }
        const depth = -sd; let m = 0;
        if (depth > 0 && depth < bevel) { const t = 1 - depth / bevel; m = t * t * (3 - 2 * t); }
        const i = (y * w + x) * 4; d[i] = 128 + Math.round(nx * m * 127); d[i + 1] = 128 + Math.round(ny * m * 127); d[i + 2] = 128; d[i + 3] = 255;
      }
      ctx.putImageData(img, 0, 0); return c.toDataURL();
    };
    const filterFor = (w, h, r, base) => {
      const key = `${w}x${h}r${r}s${base}`; if (cache.has(key)) return cache.get(key);
      if (!defs) {
        defs = document.createElementNS(NS, 'svg');
        defs.setAttribute('width', '0'); defs.setAttribute('height', '0'); defs.setAttribute('aria-hidden', 'true'); defs.style.position = 'absolute';
        document.body.appendChild(defs);
      }
      const id = `ntlg${cache.size}`, f = document.createElementNS(NS, 'filter');
      f.setAttribute('id', id); f.setAttribute('x', '0'); f.setAttribute('y', '0'); f.setAttribute('width', '100%'); f.setAttribute('height', '100%'); f.setAttribute('color-interpolation-filters', 'sRGB');
      const im = document.createElementNS(NS, 'feImage'), url = lensMap(w, h, r, Math.min(44, r, h / 2));
      im.setAttribute('href', url); im.setAttribute('x', '0'); im.setAttribute('y', '0'); im.setAttribute('width', w); im.setAttribute('height', h); im.setAttribute('preserveAspectRatio', 'none'); im.setAttribute('result', 'm');
      const dm = document.createElementNS(NS, 'feDisplacementMap');
      dm.setAttribute('in', 'SourceGraphic'); dm.setAttribute('in2', 'm'); dm.setAttribute('scale', base); dm.setAttribute('xChannelSelector', 'R'); dm.setAttribute('yChannelSelector', 'G');
      f.append(im, dm); defs.appendChild(f); cache.set(key, id); return id;
    };
    const fit = (el) => {
      if (!refract) return;
      const w = Math.round(el.offsetWidth), h = Math.round(el.offsetHeight); if (!w || !h) return;
      const r = Math.min(parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0, w / 2, h / 2);
      el.style.setProperty('--lgf', `url(#${filterFor(w, h, Math.round(r), Math.round((el.dataset.lg || 20) * 1.35))}) blur(${el.dataset.blur || 2}px) saturate(1.8) brightness(1.04)`);
    };
    const ro = window.ResizeObserver ? new ResizeObserver((es) => es.forEach((e) => fit(e.target))) : null;
    const attach = (scope = document) => scope.querySelectorAll('.lg[data-lg]').forEach((el) => { if (el._lg) return; el._lg = 1; if (ro) ro.observe(el); fit(el); });
    return { attach };
  })();
  NT.lg.attach();
  if (!reduce) {
    let raf = 0;
    addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const p = scrollY / Math.max(1, innerHeight), S = root.style;
        S.setProperty('--ha', `${(210 + p * 60) % 360}deg`); S.setProperty('--hx', `${18 + (p % 1) * 70}%`);
      });
    }, { passive: true });
  }

  /* ---------------- phone tab bar ---------------- */
  const tb = $('tabbar');
  const countEls = () => document.querySelectorAll('[data-nt-cart-count]');
  const setCount = (n) => {
    n = Math.max(0, n | 0);
    NT.cart && (NT.cart.count = n);
    const txt = n > 99 ? '99+' : String(n);
    countEls().forEach((el) => { el.textContent = txt; el.hidden = !n; });
    const label = n ? `Cart, ${n} ${n === 1 ? 'item' : 'items'}` : 'Cart';
    document.querySelectorAll('a[data-nt-cart-open]').forEach((a) => a.setAttribute('aria-label', label));
    document.querySelectorAll('[data-nt-cart-count-txt]').forEach((el) => { el.textContent = n ? `(${n})` : ''; });
  };
  window.NTTabBar = { setCount };
  if (tb) {
    const page = tb.dataset.page;
    const smooth = reduce ? 'auto' : 'smooth';
    const setOn = (k, how = 'page') => tb.querySelectorAll('[data-tb]').forEach((a) => { if (a.dataset.tb === k) a.setAttribute('aria-current', how); else a.removeAttribute('aria-current'); });
    // home: Visit is marked while the café section is on screen
    if (page === 'home') {
      const sr = $('showroom');
      if (sr && window.IntersectionObserver) new IntersectionObserver(([e]) => setOn(e.isIntersecting ? 'visit' : 'home', e.isIntersecting ? 'location' : 'page'), { rootMargin: '-45% 0px -50% 0px' }).observe(sr);
    }
    // a product has its own buy bar: the tab bar returns once the footer is reached (html.tb-off is set in theme.liquid)
    const foot = $('ntFoot');
    if (root.classList.contains('tb-off') && foot && window.IntersectionObserver) {
      new IntersectionObserver(([e]) => root.classList.toggle('tb-end', e.isIntersecting), { rootMargin: '0px 0px -40px 0px' }).observe(foot);
    }
    // a tap on where you already are takes you to its top; a section of this page scrolls to it
    tb.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-tb]'); if (!a || a.hasAttribute('data-nt-cart-open')) return;
      const u = new URL(a.getAttribute('href'), location.href);
      if (u.pathname !== location.pathname) return;
      const t = u.hash ? document.getElementById(u.hash.slice(1)) : null;
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: smooth, block: 'start' }); if (location.hash !== u.hash) history.replaceState(null, '', u.hash); return; }
      if (u.hash) return;
      if (u.search !== location.search) return;
      e.preventDefault(); scrollTo({ top: 0, behavior: smooth });
    });
    // the bar steps aside while the keyboard is up
    const typing = (el) => !!(el && el.matches && el.matches('input:not([type=button]):not([type=submit]):not([type=reset]):not([type=checkbox]):not([type=radio]):not([type=range]):not([type=color]),textarea,select,[contenteditable=""],[contenteditable="true"]'));
    addEventListener('focusin', (e) => root.classList.toggle('tb-kb', typing(e.target)));
    addEventListener('focusout', () => setTimeout(() => root.classList.toggle('tb-kb', typing(document.activeElement)), 80));
  }

  /* ---------------- cart ---------------- */
  const drawer = $('ntCart');
  const drawerSection = cfg.drawerSection || 'nt-cart-drawer';
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  const roots = () => Array.from(document.querySelectorAll('[data-ntc-root]'));
  const sectionIds = () => Array.from(new Set(roots().map((r) => r.dataset.section).filter(Boolean))).slice(0, 5);
  const sectionsFor = () => { const ids = sectionIds(); if (drawer && !ids.includes(drawerSection)) ids.unshift(drawerSection); return ids.slice(0, 5); };
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  let lastFocus = null;

  // swap each cart block for its freshly rendered copy (Section Rendering API HTML)
  const applySections = (sections) => {
    if (!sections) return null;
    let count = null;
    roots().forEach((el) => {
      const html = sections[el.dataset.section];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`[data-ntc-root][data-section="${el.dataset.section}"]`) || doc.querySelector('[data-ntc-root]');
      if (!fresh) return;
      const openNote = el.querySelector('details.ntc-note[open]');
      el.innerHTML = fresh.innerHTML;
      el.dataset.count = fresh.dataset.count;
      if (openNote) { const n = el.querySelector('details.ntc-note'); if (n) n.open = true; }
      count = parseInt(fresh.dataset.count, 10);
      pricesUpdated(el);
    });
    return count;
  };
  const busy = (on) => roots().forEach((r) => r.setAttribute('aria-busy', String(on)));

  const fetchSections = () => {
    const ids = sectionsFor(); if (!ids.length) return Promise.resolve(null);
    return fetch(`${route('root', '/').replace(/\/$/, '')}/?sections=${encodeURIComponent(ids.join(','))}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null)).catch(() => null);
  };
  const fetchCount = () => fetch(`${route('cart', '/cart')}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null)).then((c) => { if (c) setCount(c.item_count); return c; }).catch(() => null);

  const openDrawer = () => {
    if (!drawer) { location.href = route('cart', '/cart'); return; }
    if (!drawer.hidden && drawer.classList.contains('open')) return;
    setMenu(false);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    root.classList.add('ntc-lock');
    void drawer.offsetHeight; // start the slide from the closed position
    drawer.classList.add('open');
    const panel = drawer.querySelector('.ntc-panel');
    setTimeout(() => { const x = drawer.querySelector('.ntc-x'); (x || panel).focus({ preventScroll: true }); }, 60);
  };
  const closeDrawer = () => {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('open');
    root.classList.remove('ntc-lock');
    setTimeout(() => { if (!drawer.classList.contains('open')) drawer.hidden = true; }, reduce ? 0 : 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  const refresh = (opts = {}) => fetchSections().then((s) => {
    const n = applySections(s);
    if (n != null && !isNaN(n)) setCount(n); else fetchCount();
    emit('nt:cart-updated', { count: NT.cart.count, source: 'refresh' });
    if (opts.open) openDrawer();
  });

  const fail = (message) => {
    const msg = message || 'Sorry, that did not work. Please try again, or message us on WhatsApp.';
    NT.toast(msg, 4200);
    emit('nt:cart-error', { message: msg });
  };
  const readError = (r) => r.json().then((j) => { throw new Error(j.description || j.message || ''); }, () => { throw new Error(''); });

  const setBtnBusy = (btn, on) => {
    if (!btn) return;
    btn.toggleAttribute('aria-busy', on);
    if (on) { btn._ntDis = btn.disabled; btn.disabled = true; } else { btn.disabled = !!btn._ntDis; }
  };

  // add: items = [{id, quantity, properties, selling_plan}] or one item; always a real variant id
  const add = (items, opts = {}) => {
    const list = (Array.isArray(items) ? items : [items]).filter((i) => i && i.id).map((i) => Object.assign({ quantity: 1 }, i, { id: Number(i.id), quantity: Math.max(1, Number(i.quantity) || 1) }));
    if (!list.length) { fail('Please choose an option first.'); return Promise.reject(new Error('no variant')); }
    setBtnBusy(opts.button, true);
    return fetch(`${route('cartAdd', '/cart/add')}.js`, { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ items: list, sections: sectionsFor().join(','), sections_url: location.pathname }) })
      .then((r) => (r.ok ? r.json() : readError(r)))
      .then((res) => afterAdd(res, opts))
      .catch((err) => { fail(err && err.message); throw err; })
      .finally(() => setBtnBusy(opts.button, false));
  };
  const addForm = (form, button) => {
    const fd = new FormData(form);
    if (!fd.get('id')) { fail('Please choose an option first.'); return Promise.reject(new Error('no variant')); }
    fd.append('sections', sectionsFor().join(','));
    fd.append('sections_url', location.pathname);
    setBtnBusy(button, true);
    return fetch(`${route('cartAdd', '/cart/add')}.js`, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then((r) => (r.ok ? r.json() : readError(r)))
      .then((res) => afterAdd(res, {}))
      .catch((err) => { fail(err && err.message); throw err; })
      .finally(() => setBtnBusy(button, false));
  };
  const afterAdd = (res, opts) => {
    const n = applySections(res && res.sections);
    const items = res && res.items ? res.items : res ? [res] : [];
    const done = () => {
      emit('nt:cart-added', { items });
      emit('nt:cart-updated', { count: NT.cart.count, source: 'add', items });
      if (opts.open !== false) openDrawer();
      return res;
    };
    if (n != null && !isNaN(n)) { setCount(n); return done(); }
    return refresh().then(done);
  };

  const change = (key, quantity) => {
    busy(true);
    return fetch(`${route('cartChange', '/cart/change')}.js`, { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity | 0), sections: sectionsFor().join(','), sections_url: location.pathname }) })
      .then((r) => (r.ok ? r.json() : readError(r)))
      .then((cart) => {
        applySections(cart.sections);
        setCount(cart.item_count);
        emit('nt:cart-updated', { count: cart.item_count, source: 'change' });
        return cart;
      })
      .catch((err) => { fail(err && err.message); return refresh(); })
      .finally(() => busy(false));
  };

  // fix32 (28 Oct): "Switch to 10% now" on a full-price sculpture line (Egypt). Adds the piece's deposit twin with the same quantity
  // and the same line properties (a Customize line keeps its Final look / Name close-up links) plus the deposit ones the product page
  // sends, then removes the full-price line. The twin goes in first, so a failed add never loses the line.
  const egp = (cents) => 'EGP ' + Math.round(Number(cents) / 100).toLocaleString('en-US');
  const switchDep = (btn) => {
    const line = btn.closest('.ntc-line');
    if (!line || btn.disabled) return Promise.resolve();
    let props = {};
    try { props = JSON.parse(btn.dataset.props || '{}') || {}; } catch (e) { props = {}; }
    // Liquid's json gives a line's properties as [[name, value], ...] ([] when there are none)
    if (Array.isArray(props)) props = Object.fromEntries(props.filter((p) => Array.isArray(p) && p.length === 2));
    else if (!props || typeof props !== 'object') props = {};
    const full = Number(btn.dataset.fullC) || 0, dep = Number(btn.dataset.depC) || 0;
    Object.assign(props, { Payment: '10% deposit paid online, the rest in cash on delivery', 'Balance due on delivery': egp(full - dep), 'Full price': egp(full), _nt_full_variant: String(btn.dataset.fullId || '') });
    const qty = Math.max(1, parseInt(line.dataset.qty, 10) || 1);
    setBtnBusy(btn, true); busy(true);
    return fetch(`${route('cartAdd', '/cart/add')}.js`, { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ items: [{ id: Number(btn.dataset.depId), quantity: qty, properties: props }] }) })
      .then((r) => (r.ok ? r.json() : readError(r)))
      .then(() => fetch(`${route('cartChange', '/cart/change')}.js`, { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ id: line.dataset.key, quantity: 0, sections: sectionsFor().join(','), sections_url: location.pathname }) }))
      .then((r) => (r.ok ? r.json() : readError(r)))
      .then((cart) => {
        applySections(cart.sections);
        setCount(cart.item_count);
        emit('nt:cart-updated', { count: cart.item_count, source: 'deposit' });
        return cart;
      })
      .catch((err) => { fail(err && err.message); return refresh(); })
      .finally(() => { setBtnBusy(btn, false); busy(false); });
  };

  let noteT = 0;
  const saveNote = (note) => {
    clearTimeout(noteT);
    noteT = setTimeout(() => {
      fetch(`${route('cartUpdate', '/cart/update')}.js`, { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ note }) })
        .then((r) => { if (r.ok) emit('nt:cart-updated', { count: NT.cart.count, source: 'note' }); })
        .catch(() => {});
    }, 450);
  };

  NT.cart = { count: Number(cfg.cartCount) || 0, add, addForm, change, refresh, open: openDrawer, close: closeDrawer, setCount };

  // cart buttons (header on a desktop, the tab bar on phones): open the drawer; /cart without JS or on the cart page
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-nt-cart-open]');
    if (a && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-ntc-close]')) { e.preventDefault(); closeDrawer(); return; }
    const depBtn = e.target.closest('[data-ntc-dep]');
    if (depBtn) { e.preventDefault(); switchDep(depBtn); return; }
    // quantity steps and remove, inside any cart block
    const step = e.target.closest('[data-ntc-step]');
    const rm = e.target.closest('[data-ntc-remove]');
    const line = (step || rm) && (step || rm).closest('.ntc-line');
    if (line) {
      e.preventDefault();
      if (rm) { change(line.dataset.key, 0); return; }
      const input = line.querySelector('[data-ntc-input]');
      const q = Math.max(0, (parseInt(input && input.value, 10) || 0) + Number(step.dataset.ntcStep));
      if (input) input.value = q;
      change(line.dataset.key, q);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest && e.target.closest('[data-ntc-input]');
    if (input) { const line = input.closest('.ntc-line'); if (line) change(line.dataset.key, Math.max(0, parseInt(input.value, 10) || 0)); }
  });
  document.addEventListener('input', (e) => {
    const note = e.target.closest && e.target.closest('[data-ntc-note]');
    if (note) {
      // keep the drawer and the page in step, then save
      document.querySelectorAll('[data-ntc-note]').forEach((n) => { if (n !== note) n.value = note.value; });
      saveNote(note.value);
    }
  });
  // Enter in a quantity box must not submit the cart form (it would go to checkout)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ntc-input]')) { e.preventDefault(); e.target.blur(); }
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    // keep Tab inside the open drawer
    if (e.key === 'Tab' && drawer && !drawer.hidden) {
      const f = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),textarea,summary,[tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // the note is saved before leaving for checkout
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.classList && f.classList.contains('ntc-form')) { clearTimeout(noteT); return; }
  }, true);

  // any product form (form[action$="/cart/add"]) that no other script handled: add through AJAX and open the drawer.
  // Focal's product-form and the apps that call preventDefault() keep their own behaviour (we only act if nobody did).
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (e.defaultPrevented || !(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action) || form.hasAttribute('data-nt-native')) return;
    if (!drawer) return; // on /cart: let the form post normally
    e.preventDefault();
    addForm(form, e.submitter || form.querySelector('[type="submit"],button[name="add"]')).catch(() => {});
  });

  // Focal's own product form (is="product-form") adds by itself, then fires these: open our drawer instead of Focal's
  // (one capture listener on <html>: it sees the event whether Focal fires it on the form or on <html>)
  root.addEventListener('variant:added', () => refresh({ open: true }), true);
  document.addEventListener('nt:cart-refresh', (e) => refresh({ open: !!(e.detail && e.detail.open) }));
  // after your own AJAX add (e.g. Customize 1 of 1): re-render the drawer with the new line and open it
  document.addEventListener('nt:cart:open', () => refresh({ open: true }));

  // back from checkout (bfcache): the count may be stale
  addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });

  // the drawer on phones: drag the grab bar down to close
  if (drawer) {
    const panel = drawer.querySelector('.ntc-panel'), grab = drawer.querySelector('.ntc-grab');
    let y0 = null;
    const head = drawer.querySelector('.ntc-head');
    [grab, head].forEach((h) => h && h.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; panel.style.transition = 'none'; }, { passive: true }));
    drawer.addEventListener('touchmove', (e) => { if (y0 == null) return; const dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = `translateY(${dy}px)`; }, { passive: true });
    drawer.addEventListener('touchend', (e) => {
      if (y0 == null) return;
      const dy = e.changedTouches[0].clientY - y0; y0 = null;
      panel.style.transition = ''; panel.style.transform = '';
      if (dy > 90) closeDrawer();
    });
  }

  // ---------- fix 9 (owner, 28 Oct): back from checkout, once a session, Egypt only, no discount. If the cart still holds a full-price
  // sculpture that has a 10% twin (the same [data-ntc-dep] button fix 2 renders in the cart), a small panel offers the same switch.
  // Checkout click -> sessionStorage flag; the next page (or the bfcache return) reads it, clears it and checks the cart. Never on /cart.
  const CO_KEY = 'nt_co_back', CO_DONE = 'nt_co_back_done';
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } } };
  const isEG = cfg.country === 'EG';
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.ntc-form [name="checkout"]');
    if (b && isEG && !ss.get(CO_DONE)) ss.set(CO_KEY, '1');
  }, true);
  let backEl = null, backPrev = null;
  const closeBack = () => {
    if (!backEl) return;
    const el = backEl; backEl = null;
    el.classList.remove('open');
    setTimeout(() => el.remove(), reduce ? 0 : 400);
    if (backPrev && backPrev.focus && document.contains(backPrev)) backPrev.focus({ preventScroll: true });
  };
  // amounts as the shop's own money spans (Currency Converter+ takes over bare "EGP" text; html.nt-eg shows our spans)
  const moneyHtml = (cents) => { const h = NT.formatMoney(cents); return /class=["']?money/.test(h) ? h : `<span class="money">${h}</span>`; };
  const showBack = (btn) => {
    const line = btn.closest('.ntc-line');
    const qty = Math.max(1, parseInt(line && line.dataset.qty, 10) || 1);
    const full = (Number(btn.dataset.fullC) || 0) * qty, dep = (Number(btn.dataset.depC) || 0) * qty;
    const name = line && line.querySelector('.ntc-nm') ? line.querySelector('.ntc-nm').textContent.trim() : '';
    const wa = `https://wa.me/${cfg.whatsapp || '201024797078'}?text=${encodeURIComponent(`Hi NOT TOYS, I have a question about paying for ${name || 'my sculpture'}.`)}`;
    backPrev = document.activeElement;
    backEl = document.createElement('div');
    backEl.className = 'nt-back';
    backEl.setAttribute('role', 'dialog'); backEl.setAttribute('aria-modal', 'true'); backEl.setAttribute('aria-labelledby', 'ntBackT'); backEl.setAttribute('aria-describedby', 'ntBackL');
    backEl.innerHTML = `<div class="nt-back-in"><button type="button" class="nt-back-x" aria-label="Close">&times;</button><h2 id="ntBackT">Not ready to pay it all?</h2><p id="ntBackL">Pay 10% now and the rest in cash when we deliver your sculpture.</p>${full > dep && dep > 0 ? `<p class="nt-back-amt">${moneyHtml(dep)} now &middot; ${moneyHtml(full - dep)} on delivery</p>` : ''}<div class="nt-back-btns"><button type="button" class="nt-back-go">Switch to 10% now</button><a class="nt-back-wa" href="${wa}" target="_blank" rel="noopener">Ask us on WhatsApp</a></div></div>`;
    document.body.appendChild(backEl);
    void backEl.offsetHeight;
    backEl.classList.add('open');
    const go = backEl.querySelector('.nt-back-go');
    setTimeout(() => go.focus({ preventScroll: true }), 60);
    backEl.querySelector('.nt-back-x').addEventListener('click', closeBack);
    go.addEventListener('click', () => {
      if (go.disabled) return;
      go.disabled = true; go.setAttribute('aria-busy', 'true');
      // the line may have been re-rendered since: use the live button for the same line
      const live = document.querySelector(`.ntc-line[data-key="${CSS.escape(line ? line.dataset.key : '')}"] [data-ntc-dep]`) || btn;
      switchDep(live).then(() => { backPrev = null; closeBack(); openDrawer(); });
    });
    backEl.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeBack(); return; }
      if (e.key !== 'Tab') return;
      const f = Array.from(backEl.querySelectorAll('button:not([disabled]),a[href]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };
  const checkBack = () => {
    if (!ss.get(CO_KEY)) return;
    ss.set(CO_KEY, null);
    if (!isEG || ss.get(CO_DONE) || cfg.template === 'cart' || !drawer) return;   // on /cart the line's own button is enough
    refresh().then(() => {
      const btn = document.querySelector('.ntc-line [data-ntc-dep]');
      if (!btn || NT.cart.count < 1 || backEl) return;
      ss.set(CO_DONE, '1');
      if (!drawer.hidden) closeDrawer();
      showBack(btn);
    }).catch(() => {});
  };
  addEventListener('pageshow', () => setTimeout(checkBack, 300));

  setCount(NT.cart.count);
})();

/* review 22 Oct: a cart line for a colour that has no image of its own in Shopify showed the product's first photo (a white Mighty
   for a Dark Shadow order). Use the same studio photo the product page shows for that colour and crown (nt-data.json). */
(() => {
  let DATA = null, loading = null, t = 0;
  const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const ncr = (s) => { const n = norm(s); if (!n || n === '-') return '-'; if (n.includes('timeless')) return 'timeless'; if (n.includes('orchid')) return 'orchid'; if (n.indexOf('colo') === 0) return 'colored'; return n; };
  const load = (src) => (DATA ? Promise.resolve(DATA) : (loading = loading || fetch(src).then((r) => r.json()).then((j) => (DATA = j)).catch(() => null)));
  const fix = () => {
    const lines = document.querySelectorAll('.ntc-line[data-nt-fix][data-nt-handle]');
    if (!lines.length) return;
    load(lines[0].dataset.ntData).then((A) => {
      if (!A || !A.p) return;
      lines.forEach((li) => {
        const D = A.p[li.dataset.ntHandle]; if (!D || !D.front || !D.keys) return;
        let opts = []; try { opts = JSON.parse(li.dataset.ntOpts || '[]'); } catch (e) { return; }
        const cr = opts.find((o) => /crown/i.test(o.n) || (/material/i.test(o.n) && /crown/i.test(o.v)));
        const co = opts.find((o) => o !== cr && /colou?r/i.test(o.n));
        const c = co ? norm(co.v) : 'default', r = cr ? ncr(cr.v) : '-';
        let i = D.keys[`${c}|${r}`]; if (i === undefined) i = D.keys[`${c}|-`];
        const n = i === undefined ? undefined : D.front[i];
        const img = li.querySelector('.ntc-ph img');
        li.removeAttribute('data-nt-fix');
        if (n === undefined || n === null || !img) return;
        const u = A.base + 'nt26-' + String(n).padStart(3, '0') + (n >= 790 ? '.png' : '.jpg');
        img.src = `${u}?width=240`; img.srcset = `${u}?width=160 160w, ${u}?width=240 240w, ${u}?width=360 360w`;
      });
    });
  };
  const soon = () => { if (!t) t = setTimeout(() => { t = 0; fix(); }, 80); };   // throttle: busy pages never starve it
  document.addEventListener('nt:cart-updated', soon);
  if (window.MutationObserver) new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') soon(); else document.addEventListener('DOMContentLoaded', soon);
})();

/* tech review 23 Oct: a failed add to cart from the Focal product form (sold out, busy store, network drop) showed nothing.
   Watch every /cart/add call, whoever makes it, and show the toast with Shopify's message when it fails. */
(() => {
  if (!window.fetch || window.__ntAddWatch) return; window.__ntAddWatch = true;
  const orig = window.fetch.bind(window);
  const isAdd = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u && u.url ? u.url : u));
  window.fetch = (u, o) => orig(u, o).then((r) => {
    if (isAdd(u) && !r.ok && window.NT && NT.toast) {
      r.clone().json().then((j) => NT.toast(j.description || j.message || 'Sorry, that did not work. Please try again, or message us on WhatsApp.', 4200), () => NT.toast('Sorry, that did not work. Please try again, or message us on WhatsApp.', 4200));
    }
    return r;
  }, (e) => { if (isAdd(u) && window.NT && NT.toast) NT.toast('No connection. Please try again.', 4200); throw e; });
})();

/* owner, 23 Oct: /pages/about-us#made landed on the Characters. The browser jumps to the anchor before the lazy pictures above it
   have their height; the page then grows and pushes the target down. Re-anchor once everything above has settled. */
(() => {
  const go = () => {
    const id = decodeURIComponent((location.hash || '').slice(1)); if (!id) return;
    const el = document.getElementById(id); if (!el) return;
    const top = el.getBoundingClientRect().top, want = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    if (Math.abs(top - want) > 24) el.scrollIntoView({ block: 'start' });
  };
  addEventListener('load', () => { go(); setTimeout(go, 700); setTimeout(go, 1800); });
  addEventListener('hashchange', () => setTimeout(go, 400));
})();

/* owner, 28 Oct: a live delivery date for made-to-order pieces in Egypt, counted from right now (Cairo time):
   7 to 10 working days, Sunday to Thursday (the shipping policy), e.g. "at your door Sun 9 – Wed 12 Nov". */
(() => {
  const els = document.querySelectorAll('[data-nt-eta]'); if (!els.length) return;
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
  const day0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const plus = (n) => { const x = new Date(day0); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 5 && w !== 6) k++; } return x; };
  const fmt = (x, withMonth) => x.toLocaleDateString('en-GB', withMonth ? { weekday: 'short', day: 'numeric', month: 'short' } : { weekday: 'short', day: 'numeric' });
  const a = plus(7), b = plus(10);
  const txt = `at your door ${fmt(a, a.getMonth() !== b.getMonth())} – ${fmt(b, true)}`;
  els.forEach((el) => { el.textContent = txt; });
})();
